import type {NamedSetState} from 'app/gemStore/devtools';

import type {SLSPResourceSigningSlice, SLSPResourceSigningStoreState, SetSlspTransactionSignedParams} from './types';

const slspResourceSigningInitialState: SLSPResourceSigningStoreState = {
    signUrl: null,
    transactionData: null,
    signingInProgress: false,
    signId: null,
    selectedAuthType: null,
    authorizationTypes: [],
    authorizationInProgress: false,
    isAuthorized: false,
    signErrorOccured: false,
    successSignResponseData: {},
    headers: {},
    flags: [],
    signExtraBody: {},
};

export const createSlspResourceSigningSlice = (set: NamedSetState<SLSPResourceSigningSlice>, get: () => SLSPResourceSigningSlice) => ({
    slspResourceSigning: slspResourceSigningInitialState,
    setSlspSignEndpointUrl: (signUrl: string) => {
        set({slspResourceSigning: {...get().slspResourceSigning, signUrl}}, false, 'slspResourceSigning/setSlspSignEndpointUrl');
    },
    setSlspSigningInProgress: (signingInProgress: boolean) => {
        const currentState = get().slspResourceSigning;
        let nextState = {...currentState, signingInProgress};

        if (signingInProgress) {
            nextState = {
                ...nextState,
                selectedAuthType: null,
                authorizationTypes: [],
                signId: null,
            };
        }

        set({slspResourceSigning: nextState}, false, 'slspResourceSigning/setSlspSigningInProgress');
    },
    setSlspTransactionSigned: ({signId, responseData}: SetSlspTransactionSignedParams) => {
        set(
            {
                slspResourceSigning: {
                    ...get().slspResourceSigning,
                    signErrorOccured: false,
                    signId,
                    selectedAuthType: responseData.authorizationType,
                    flags: responseData.flags ?? [],
                    authorizationTypes: responseData.scenarios.map((type) => type[0]),
                },
            },
            false,
            'slspResourceSigning/setSlspTransactionSigned',
        );
    },
    setSlspAuthorizationType: (selectedAuthType: string) => {
        set({slspResourceSigning: {...get().slspResourceSigning, selectedAuthType}}, false, 'slspResourceSigning/setSlspAuthorizationType');
    },
    setSlspAuthorizationInProgress: (authorizationInProgress: boolean) => {
        set({slspResourceSigning: {...get().slspResourceSigning, authorizationInProgress}}, false, 'slspResourceSigning/setSlspAuthorizationInProgress');
    },
    setSlspAuthorizationSuccess: (successSignResponseData: unknown) => {
        const currentState = get().slspResourceSigning;
        set(
            {
                slspResourceSigning: {
                    ...currentState,
                    isAuthorized: true,
                    authorizationTypes: currentState.selectedAuthType ? [currentState.selectedAuthType] : [],
                    successSignResponseData,
                },
            },
            false,
            'slspResourceSigning/setSlspAuthorizationSuccess',
        );
    },
    setSlspSignApiErrorOccured: () => {
        set(
            {
                slspResourceSigning: {
                    ...get().slspResourceSigning,
                    signingInProgress: false,
                    signErrorOccured: true,
                },
            },
            false,
            'slspResourceSigning/setSlspSignApiErrorOccured',
        );
    },
    setSlspHeaders: (headers: HeadersInit) => {
        set({slspResourceSigning: {...get().slspResourceSigning, headers}}, false, 'slspResourceSigning/setSlspHeaders');
    },
    setSlspSignExtraBody: (signExtraBody: Record<string, unknown>) => {
        set({slspResourceSigning: {...get().slspResourceSigning, signExtraBody}}, false, 'slspResourceSigning/setSlspSignExtraBody');
    },
});
